import { ModalFooterProps } from '@components/shared/modal-footer.component';
import { FunctionComponent, ReactNode } from 'react';
import { Modal } from './modal.component.tsx';

type SuccessModalProps = {
  continueMessage?: string;
  information?: ReactNode;
  isOpen: boolean;
  nextStep?: string;
  onClose: () => void;
  onContinue?: () => void;
  text: string;
  title: string;
  width?: string;
};

export const SuccessModal: FunctionComponent<SuccessModalProps> = ({
  continueMessage = 'Continue',
  information,
  isOpen,
  nextStep,
  onClose,
  onContinue,
  text,
  title,
  width = '400px',
}) => {
  const footer: ModalFooterProps = {
    rightButton: {
      onClick: onContinue ? onContinue : onClose,
      children: continueMessage,
    },
    leftButton: {
      onClick: onClose,
      children: 'Dismiss',
      variant: 'secondary',
    },
  };

  return (
    <Modal
      centered
      footer={footer}
      isOpen={isOpen}
      onClose={onClose}
      width={width}
    >
      <div className="flex h-full w-full flex-col items-center gap-4">
        <div className="flex flex-col items-center gap-4 py-12">
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Success Icon</title>
            <rect
              width="56"
              height="56"
              rx="28"
              fill="#00BD79"
              fillOpacity="0.1"
            />
            <path
              d="M18.9546 29.9546L24.9548 35.9548L39.9552 20.9543"
              stroke="#00BD79"
              strokeWidth="2.5"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </svg>
          <div className="text-center font-normal text-gray-900 text-lg mb-2">{title}</div>
          <div className="text-center font-light text-gray-600 w-4/5">{text}</div>
          {information}
          {nextStep && <div className="text-center font-light text-gray-600 w-4/5 mt-4">{nextStep}</div>}
        </div>
      </div>
    </Modal>
  );
};
